import React, { useState } from 'react';
import IPTB from '../controls/IPTB';
import IPTextArea from '../controls/IPTextArea';
import IPCheck from '../controls/IPCheck';
import IPSelect from '../controls/IPSelect';
import IPTree from '../controls/IPTree';
import IPCheckList from '../controls/IPCheckList';
import { useSelector, useDispatch } from 'react-redux';
import allActions from '../actions/index';






const PropertiesContainer = (props) => {

    const returnElement = (obj) => {

        switch (obj.type) {
            case "string": return (<IPTB obj={obj} setValue={props.setPropertyValue} key={obj.id} readonly={props.readonly} />);
            case "text": return (<IPTextArea obj={obj} setValue={props.setPropertyValue} key={obj.id} readonly={props.readonly} />);
            case "check": return (<IPCheck obj={obj} setValue={props.setPropertyValue} key={obj.id} readonly={props.readonly} />);
            case "select": return (<IPSelect obj={obj} setValue={props.setPropertyValue} key={obj.id} readonly={props.readonly} />);
            case "tree": return (<IPTree obj={obj} setValue={props.setPropertyValue} key={obj.id} readonly={props.readonly} />);
            case "checklist": return (<IPCheckList obj={obj} setValue={props.setPropertyValue} key={obj.id} readonly={props.readonly} />);
            default: return (<div>Uknown element</div>);
        }
    }




    return (
        <div className="container">

            {
                props.obj && props.obj.map(item =>

                    <div className="form-row" key={item.id}>

                        {returnElement(item)}
                    </div>
                )
            }
        </div>

    );
}


export default PropertiesContainer;